import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Core } from "@faire/design-tokens";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useChatCsatStore } from "../hooks/ChatCsatContextStore";
export var CsatTitle = function CsatTitle() {
  var _useChatCsatStore = useChatCsatStore(["surveyType"]),
    _useChatCsatStore2 = _slicedToArray(_useChatCsatStore, 1),
    surveyType = _useChatCsatStore2[0].surveyType;
  if (surveyType === "chat") {
    return /*#__PURE__*/React.createElement(Typography, {
      variant: "pageHeaderSerifRegular",
      color: Core.text["default"]
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "mycj0K",
      defaultMessage: "How can we improve?"
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular",
    color: Core.text["default"]
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Wyh7bV",
    defaultMessage: "Help us improve"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular",
    color: Core.text["default"]
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bZ1g2G",
    defaultMessage: "Your feedback is very valuable to us. Please share how your support experience could\u2019ve been better."
  })));
};